import {ReportLocationModel} from "../../models/reports/ReportLocationModel";

export class ReportLocationCtrl {
    public static $inject = ['$scope','ReportLocationModel'];
    constructor(public $scope:any, public model:ReportLocationModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.searchText],(newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}

